import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useCurrentUser } from "@/hooks/useCurrentUser";

/**
 * Resolves `/`. Anonymous visitors and students land on the demo gateway
 * (unchanged behaviour -- the marketing site at staxed.in is the real
 * landing page). A signed-in parent has no use for /subjects, so they go
 * straight to their portal.
 */
export function HomeRedirect() {
  const { status } = useAuth();
  const me = useCurrentUser();

  if (status === "loading" || (status === "authenticated" && me.isLoading)) {
    return (
      <div className="flex min-h-screen items-center justify-center text-text-muted text-sm">
        Loading…
      </div>
    );
  }

  if (status === "authenticated" && me.data?.role_id === "PARENT") {
    return <Navigate to="/parent" replace />;
  }

  return <Navigate to="/subjects" replace />;
}
